import { render } from "./TableCard.vue?vue&type=template&id=56a34a16&scoped=true"
import script from "./TableCard.vue?vue&type=script&lang=js"
export * from "./TableCard.vue?vue&type=script&lang=js"

import "./TableCard.vue?vue&type=style&index=0&id=56a34a16&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a34a16"]])

export default __exports__